export default __webpack_public_path__ + "static/media/hlthtek-login.44b120ef.jpeg";